import {
  IconLayoutDashboard,
  IconBuilding,
  IconBed,
  IconCalendarEvent,
  IconReceipt2,
  IconMail,
} from "@tabler/icons";
import { UserType } from "store/constant";

const icons = {
  IconLayoutDashboard,
  IconBuilding,
  IconBed,
  IconCalendarEvent,
  IconReceipt2,
  IconMail,
};

export const getUtilities = () => {
  const userType = localStorage.getItem("userType");
  const userRoleName = localStorage.getItem("userRoleName");
  const isSuperAdmin = userRoleName === "Admin" || userType === "Admin";
  const permissionsStr = localStorage.getItem("userPermissions");
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsStr) || [];
  } catch (e) {
    permissions = [];
  }

  const moduleMap = {
    properties: "property",
    kyc: "kyc",
    investments: "investment",
    "referral-earnings": "referral",
    users: "user",
    contacts: "contact",
    roles: "role",
    "role-assignment": "assignment"
  };

  const hasPerm = (id) => {
    if (isSuperAdmin) return true;
    const moduleName = moduleMap[id];
    if (!moduleName) return true;
    return permissions.includes(`${moduleName}:read`);
  };

  const adminMenu = [
    // =====================
    // DASHBOARD
    // =====================
    {
      id: "dashboard",
      title: "Dashboard",
      type: "group",
      children: [
        {
          id: "dashboard-home",
          title: "Dashboard",
          type: "item",
          url: "/dashboard",
          icon: icons.IconLayoutDashboard,
        },
      ],
    },

    // =====================
    // PROPERTY MANAGEMENT
    // =====================
    {
      id: "management",
      title: "Management",
      type: "group",
      children: [
        {
          id: "properties",
          title: "Properties",
          type: "item",
          url: "/property",
          icon: icons.IconBuilding,
        },
        {
          id: "kyc",
          title: "KYC",
          type: "item",
          url: "/kyc",
          icon: icons.IconReceipt2,
        },
        {
          id: "investments",
          title: "Investments",
          type: "item",
          url: "/investment",
          icon: icons.IconCalendarEvent,
        },
        {
          id: "referral-earnings",
          title: "Referral Earnings",
          type: "item",
          url: "/referral",
          icon: icons.IconReceipt2,
        },
        {
          id: "users",
          title: "Users",
          type: "item",
          url: "/users",
          icon: icons.IconLayoutDashboard,
        },
        {
          id: "contacts",
          title: "Contacts",
          type: "item",
          url: "/contacts",
          icon: icons.IconMail,
        },
        {
          id: "roles",
          title: "Roles",
          type: "item",
          url: "/roles",
          icon: icons.IconReceipt2,
        },
        {
          id: "role-assignment",
          title: "Role Assignment",
          type: "item",
          url: "/roles/assignment",
          icon: icons.IconReceipt2,
        },
      ],
    },
  ];

  if (userType === UserType.Admin) {
    return adminMenu.map(group => {
      if (group.id === "management" && group.children) {
        return {
          ...group,
          children: group.children.filter(child => hasPerm(child.id))
        };
      }
      return group;
    });
  }

  return [];
};
